<div @statisticsState
  class="statistics-audits-container">

  <pm-audit-trail-audits [data]="auditsData"></pm-audit-trail-audits>

</div>
